import React, { Fragment, useState } from 'react'
import { LOCALES } from './locales'

const LanguageTable = React.forwardRef((props, ref) => {
    const { tableLabel, name , dropdownIcon} = props
    const [data, setData] = useState(props.data || [])
    const [selectedLocale, setSelectedLocale] = useState('')

    return <Fragment>
        <input name={name} ref={ref} value={JSON.stringify(data)} className={`hidden`}/>

        <div className={'flex flex-row justify-between items-baseline py-2'}>
            {tableLabel && <span>{tableLabel}</span>}
            <div className={'ml-2 flex flex-row justify-between items-baseline'}>
                <div className="inline-block relative">
                    <select
                        className='w-56 block appearance-none p-2 rounded-sm bg-transparent border-2 border-light-gray-100'
                        value={selectedLocale}
                        onChange={(e) => setSelectedLocale(e.target.value)}>
                        <option value=''>Please choose a language</option>
                        {Object.entries(LOCALES).map(([k, l]) => <option key={k} value={k}>{`${l} [${k}]`}</option>)}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center text-gray-700 p-2">
                        <img src={dropdownIcon}/>
                    </div>
                </div>
                <button className='btn-text-yellow ml-4 outline-none focus:outline-none'
                        diabled={selectedLocale === ''}
                        onClick={(e) => {
                            e.preventDefault()
                            if (!data.includes(selectedLocale) && selectedLocale in LOCALES) {
                                setData([...data, selectedLocale])
                            }
                            setSelectedLocale('')
                        }}>Add
                </button>
            </div>
        </div>

        <div className='w-full text-center pb-8'>
            <table className="table-auto w-full text-left">
                <thead className="bg-dark-blue-700 mb-2">
                <tr>
                    <th className='font-thin text-sm pl-4' style={{ width: '34%' }}>Code</th>
                    <th className='font-thin text-sm pl-4' style={{ width: '33%' }}>Language</th>
                    <th className='font-thin text-sm pl-4' style={{ width: '33%' }}></th>
                </tr>
                </thead>
                <tbody>
                {data && data.map(item => <tr className='hover:bg-dark-blue-700' key={item}>
                        <td className='pl-4'>{item}</td>
                        <td className='pl-4'>{LOCALES[item]}</td>
                        <td className='py-1 flex justify-end'>
                            <button className='btn-text-yellow ml-4 focus:outline-none' onClick={(e) => {
                                e.preventDefault()
                                setData(data.filter(v => v !== item))
                            }}>Remove
                            </button>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
            {data.length === 0 ? <div className="p-8">Nothing has been added.</div> : null}
        </div>
    </Fragment>
})

export default LanguageTable
